import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

import { MailSentIcon } from "@/assets/icons";
import { useNavigation } from "@/shared/hooks";

import { StyledIndications } from "../../../styled";
import { StyledEmail } from "./styled";

type EmailSentProps = {
    email: string;
};

const EmailSent: FC<EmailSentProps> = ({ email }) => {
    const { t } = useTranslation();
    const { navToRoot } = useNavigation();

    return (
        <>
            <div className="title">{t("ResetPassword.EmailSent.Title")}</div>
            <div style={{ textAlign: "center" }}>
                <MailSentIcon />
                <StyledIndications style={{ marginTop: "1.6rem" }}>
                    <b>{t("ResetPassword.EmailSent.EmailSentTo")}</b>
                </StyledIndications>
                <StyledEmail data-testid="emailField">{email}</StyledEmail>

                <StyledIndications>
                    <p>{t("ResetPassword.EmailSent.Message")}</p>
                </StyledIndications>
            </div>

            <div className="form-bottom-container">
                <Button data-testid="button_back_to_login" onClick={() => navToRoot()} fullWidth variant="outlined">
                    {t("ResetPassword.EmailSent.BackToLogin")}
                </Button>
            </div>
        </>
    );
};

export default EmailSent;
